import { render, staticRenderFns } from "./DeadPataByReasonModal.vue?vue&type=template&id=482dbaaa"
import script from "./DeadPataByReasonModal.vue?vue&type=script&lang=js"
export * from "./DeadPataByReasonModal.vue?vue&type=script&lang=js"
import style0 from "./DeadPataByReasonModal.vue?vue&type=style&index=0&id=482dbaaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports